import React from "react";
import { Helmet } from "react-helmet";


import pharmaceuticalManufacute from '../assets/pharmaceutical-manufacute.webp'

function About() {
  return (
    <div>
      <Helmet>
        <title>About Leocord | Pharmaceutical Supplier for Hospitals</title>

        <meta
          name="description"
          content="Learn about Leocord, a trusted pharmaceutical supplier providing high-quality medicines and healthcare solutions to hospitals, clinics, and healthcare institutions."
        />

        <meta
          name="keywords"
          content="about pharmaceutical supplier, pharma distribution company, healthcare pharmaceutical supplier India"
        />

        <link rel="canonical" href="https://leaocordhealthcare.com/about" />

        <meta property="og:title" content="Leocord Pharmaceutical Supplier" />
        <meta
          property="og:description"
          content="Trusted pharmaceutical supplier delivering healthcare medicines to hospitals and clinics."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://leocordhealthcare.com/" />
      </Helmet>

      {/* ================= PAGE HEADER ================= */}
      <section className="about-header">
        <div className="container">
          <h1>About Leocord</h1>
          <p className="lead mt-3">
            Leocord is committed to delivering high-quality pharmaceutical solutions that support hospitals, healthcare institutions, and medical professionals with reliability, compliance, and innovation.
          </p>
        </div>
      </section>

      <section className="section py-5 bg-light">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6">
              <h2 className="fw-bold mb-4">Who We Are</h2>
              <p>
                Leocord is a trusted pharmaceutical supplier dedicated to delivering high-quality medicines and healthcare products to hospitals, clinics, and healthcare institutions. Our mission is to support the healthcare ecosystem by ensuring reliable access to pharmaceutical products that meet the highest standards of safety, quality, and regulatory compliance.
              </p>

              <p>
                With a strong focus on efficiency and reliability, Leocord works closely with healthcare providers to streamline pharmaceutical distribution and ensure timely delivery of essential medicines. Our commitment to excellence, integrity, and innovation helps healthcare institutions maintain uninterrupted patient care.
              </p>
            </div>

            <div className="col-lg-6">
              <img
                src={pharmaceuticalManufacute}
                alt="Pharmaceutical Manufacturing"
                className="img-fluid rounded shadow"
              />
            </div>

          </div>
        </div>
      </section>
      {/* ================= MISSION ================= */}
      <section className="section py-5">
        <div className="container text-center">
          <div className="row">
            <div className="col-lg-6">
              <h2 className="fw-bold mb-4">Our Mission</h2>
              <p>
                To empower healthcare institutions with a reliable supply of high-quality, 
                regulatory-compliant pharmaceutical products that enhance patient care and 
                support the evolving needs of institutional healthcare providers across India.
              </p> 
            </div>
            <div className="col-lg-6">
              <h2 className="fw-bold mb-4">Our Vision</h2>
              <p>
                To become a nationally recognized institutional pharmaceutical partner, 
                known for regulatory integrity, operational excellence, and 
                long-term healthcare impact.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= CORE VALUES ================= */}
      <section className="section py-5">
        <div className="container text-center">
          <h2 className="fw-bold mb-5">Our Core Values</h2>

          <div className="row g-4">

            <div className="col-md-3">
              <div className="">
                <h5>Regulatory Accountability</h5>
                <p className="small text-muted">
                  Adhering strictly to pharmaceutical compliance and governance standards.
                </p>
              </div>
            </div>

            <div className="col-md-3">
              <div className="">
                <h5>Ethical Practices</h5>
                <p className="small text-muted">
                  Maintaining transparency and integrity in every institutional partnership.
                </p>
              </div>
            </div>

            <div className="col-md-3">
              <div className="">
                <h5>Quality Excellence</h5>
                <p className="small text-muted">
                  Ensuring consistent therapeutic effectiveness through stringent quality control.
                </p>
              </div>
            </div>

            <div className="col-md-3">
              <div className="">
                <h5>Supply Reliability</h5>
                <p className="small text-muted">
                  Delivering uninterrupted pharmaceutical supply across institutional networks.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="section py-5">
        <div className="container text-center">

          <h2 className="fw-bold mb-5">Why Choose Leocord</h2>

          <div className="row g-4">

            <div className="col-md-4">
              <h5>Regulatory Compliance</h5>
              <p className="text-muted">
                All products comply with national pharmaceutical regulations
                and quality assurance standards.
              </p>
            </div>

            <div className="col-md-4">
              <h5>Reliable Supply Chain</h5>
              <p className="text-muted">
                Efficient procurement and logistics ensure uninterrupted
                medicine availability.
              </p>
            </div>

            <div className="col-md-4">
              <h5>Institutional Focus</h5>
              <p className="text-muted">
                Dedicated support for hospitals, clinics, and healthcare networks.
              </p>
            </div>

          </div>

        </div>
      </section>

      <section className="section py-5 bg-light text-center">
        <div className="container">

          <div className="row">

            <div className="col-md-3 col-6">
              <h3 className="fw-bold text-primary">100+</h3>
              <p className="text-muted">Products</p>
            </div>

            <div className="col-md-3 col-6">
              <h3 className="fw-bold text-primary">50+</h3>
              <p className="text-muted">Hospital Partners</p>
            </div>

            <div className="col-md-3 col-6">
              <h3 className="fw-bold text-primary">25+</h3>
              <p className="text-muted">Therapeutic Segments</p>
            </div>

            <div className="col-md-3 col-6">
              <h3 className="fw-bold text-primary">10+</h3>
              <p className="text-muted">Years Experience</p>
            </div>

          </div>

        </div>
      </section>

      

    </div>
  );
}

export default About;